import Tabs from "@/v2-ui/tabs"
import { useTableContext, type TablePanel } from "../table.context"

/**
 * Simple / Advanced switch shared by both filter panels. Drives the shared
 * `activePanel`, so the toolbar exposes a single filter surface with two
 * modes (rather than two separate toolbar buttons).
 */
function TableFilterPanelTabs() {
  const { activePanel, setActivePanel } = useTableContext()

  return (
    <Tabs
      value={activePanel === "advancedFilter" ? "advancedFilter" : "filter"}
      onValueChange={(value) => setActivePanel(value as TablePanel)}
    >
      <Tabs.List>
        <Tabs.Trigger value="filter" size="sm">
          Simple
        </Tabs.Trigger>
        <Tabs.Trigger value="advancedFilter" size="sm">
          Advanced
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs>
  )
}

export default TableFilterPanelTabs
